module.exports = __webpack_public_path__ + "static/Kwera_Credits_Anna_Photo-d7a6e6f971c5e497f06b1d4cffe51869.png";